export interface FacetValuesDTO {
  values: string[];
}

export interface RangeFacetValuesDTO {
  values: {
    from: number;
    fromUnit: string;
    to: number;
    toUnit: string;
  }[];
}

export type FacetValuesType =
  | "ColourGeneric"
  | "Plate"
  | "SaleLocation"
  | "Grade"
  | "SaleChannel"
  | "VatType"
  | "SaleType"
  | "Make"
  | "Model"
  | "ModelGroup"
  | "Derivative"
  | "BodyType"
  | "FuelType"
  | "Transmission"
  | "EngineCapacity"
  | "NumberOfDoors"
  | "HybridType";

export type RangeFacetValuesType =
  | "Mileage"
  | "CapCleanPrice"
  | "DateRegistered";

export type CheckboxFiltersType =
  | "MileageWarranted"
  | "HasConditionReport"
  | "HasMechanicalReport"
  | "LogbookStatus"
  | "MissingMileage"
  | "AwaitingAppraisal";

export enum FacetValues {
  COLOUR_GENERIC = "ColourGeneric",
  PLATE = "Plate",
  SALE_LOCATION = "SaleLocation",
  GRADE = "Grade",
  SALE_CHANNEL = "SaleChannel",
  VAT_TYPE = "VatType",
  SALE_TYPE = "SaleType",
  MAKE = "Make",
  MODEL = "Model",
  MODEL_GROUP = "ModelGroup",
  DERIVATIVE = "Derivative",
  BODY_TYPE = "BodyType",
  FUEL_TYPE = "FuelType",
  HYBRID_TYPE = "HybridType",
  TRANSMISSION = "Transmission",
  ENGINE_CAPACITY = "EngineCapacity",
  NUMBER_OF_DOORS = "NumberOfDoors",
}

export enum RangeFacetValues {
  MILEAGE = "Mileage",
  CAP_CLEAN_PRICE = "CapCleanPrice",
  DATE_REGISTERED = "DateRegistered",
}

export enum CheckboxFilters {
  MILEAGE_WARRANTED = "MileageWarranted",
  HAS_CONDITION_REPORT = "HasConditionReport",
  HAS_MECHANICAL_REPORT = "HasMechanicalReport",
  LOGBOOK_STATUS = "LogbookStatus",
  MISSING_MILEAGE = "MissingMileage",
  AWAITING_APPRAISAL = "AwaitingAppraisal",
}
